/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Fokus_S1Inputs */

const en_tut_fokus_s1 = /** @type {(inputs: Tut_Fokus_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For yourself: press **Fokus 25 menit** in the bar under the map. Your presence status follows, and it ends on its own.`)
};

const id_tut_fokus_s1 = /** @type {(inputs: Tut_Fokus_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk diri sendiri: tekan **Fokus 25 menit** di bar bawah peta. Status Anda ikut berubah di Presence, dan berakhir otomatis.`)
};

/**
* | output |
* | --- |
* | "For yourself: press **Fokus 25 menit** in the bar under the map. Your presence status follows, and it ends on its own." |
*
* @param {Tut_Fokus_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_fokus_s1 = /** @type {((inputs?: Tut_Fokus_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Fokus_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_fokus_s1(inputs)
	return en_tut_fokus_s1(inputs)
});